import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useData } from '../../contexts/DataContext';
import { useAuth } from '../../contexts/AuthContext';
import AdminLayout from '../../components/AdminLayout';

const SENSACAO = { facil: { label: 'Fácil', color: '#2E7D32', bg: 'rgba(76,175,80,0.1)' }, ok: { label: 'Ok', color: '#5B402E', bg: 'rgba(200,146,42,0.1)' }, dificil: { label: 'Difícil', color: '#E53935', bg: 'rgba(229,57,53,0.1)' } };

const s = {
  header: { marginBottom: '32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  title: { fontFamily: "'Inter', sans-serif", fontSize: '34px', fontWeight: 700, color: 'var(--text)' },
  titleSpan: { fontStyle: 'italic', color: 'var(--accent)' },
  backBtn: { padding: '10px 20px', background: 'transparent', border: '1px solid var(--divider)', borderRadius: 'var(--r-btn)', fontSize: '12px', color: 'var(--text-2)', cursor: 'pointer', letterSpacing: '0.06em', textTransform: 'uppercase' },
  empty: { padding: '60px 40px', textAlign: 'center', background: 'var(--surface)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', color: 'var(--text-2)', fontSize: '14px', boxShadow: 'var(--sh-card)' },
  checkinCard: { background: 'var(--surface)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', marginBottom: '12px', overflow: 'hidden', boxShadow: 'var(--sh-card)' },
  checkinHeader: { padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', cursor: 'pointer' },
  checkinTitle: { fontSize: '15px', fontWeight: 600, color: 'var(--text)' },
  checkinMeta: { fontSize: '12px', color: 'var(--text-2)', marginTop: '2px' },
  checkinDate: { fontSize: '12px', color: 'var(--text-2)' },
  progressoBadge: { fontSize: '11px', fontWeight: 700, padding: '4px 11px', borderRadius: '100px', whiteSpace: 'nowrap' },
  chevron: { color: 'var(--text-2)', flexShrink: 0, transition: 'transform 0.15s' },
  exercicioRow: { padding: '14px 24px', borderBottom: '1px solid rgba(37,28,25,0.04)', display: 'grid', gridTemplateColumns: '24px 1fr auto', gap: '12px', alignItems: 'center' },
  checkDone: { width: '20px', height: '20px', borderRadius: '50%', background: 'var(--text)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#FAF7F2', flexShrink: 0 },
  checkPending: { width: '20px', height: '20px', borderRadius: '50%', border: '1.5px solid rgba(37,28,25,0.2)', flexShrink: 0 },
  exNome: { fontSize: '13px', fontWeight: 500, color: 'var(--text)' },
  exMeta: { fontSize: '11px', color: 'var(--text-2)', marginTop: '2px' },
  exObs: { fontSize: '11px', color: 'var(--text-3)', marginTop: '3px', fontStyle: 'italic' },
  badge: { padding: '3px 10px', borderRadius: '100px', fontSize: '10px', fontWeight: 600, letterSpacing: '0.04em', whiteSpace: 'nowrap' },
  metaChip: { padding:'4px 9px', borderRadius:'100px', background:'var(--bg)', color:'var(--text-2)', fontSize:'11px' },
  filterRow: { display: 'flex', gap: '8px', marginBottom: '24px', flexWrap: 'wrap' },
  filterBtn: { padding: '7px 16px', border: '1px solid var(--divider)', borderRadius: 'var(--r-btn)', background: 'transparent', fontSize: '12px', color: 'var(--text-2)', cursor: 'pointer' },
  filterBtnActive: { background: 'var(--text)', color: '#FAF7F2', borderColor: 'var(--text)' },
};

export default function Checkins() {
  const { checkins, treinos, feedbacksTreino } = useData();
  const { alunas } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [filtro, setFiltro] = useState(searchParams.get('aluna') || 'todos');
  const [periodo, setPeriodo] = useState('30');
  const [somenteAtencao, setSomenteAtencao] = useState(false);
  const [abertos, setAbertos] = useState({});

  const formatDate = (iso) => new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

  const checkinsFiltrados = checkins
    .filter(c => filtro === 'todos' || c.alunaId === filtro)
    .filter(c => periodo === 'todos' || Date.now() - new Date(c.criadoEm).getTime() <= Number(periodo) * 86400000)
    .filter(c => !somenteAtencao || c.notaGeral === 'dificil' || (c.exercicios || []).some(ex => !ex.concluido || ex.sensacao === 'dificil' || ex.obs));

  function toggleAberto(id) {
    setAbertos(a => ({ ...a, [id]: !a[id] }));
  }

  return (
    <AdminLayout>
      <div style={s.header}>
        <h1 style={s.title}>Check-ins <span style={s.titleSpan}>das Alunas</span></h1>
        <button style={s.backBtn} onClick={() => navigate('/admin')}>← Voltar</button>
      </div>

      <div style={{ ...s.filterRow, alignItems:'center', padding:'14px', background:'var(--surface)', border:'1px solid var(--divider)', borderRadius:'18px' }}>
        <select aria-label="Filtrar por aluna" value={filtro} onChange={e => setFiltro(e.target.value)} style={{ flex:'1 1 220px', minHeight:'40px', padding:'0 12px', border:'1px solid var(--divider)', borderRadius:'999px', background:'var(--surface)', color:'var(--text)' }}>
          <option value="todos">Todas as alunas</option>
          {alunas.filter(a => a.role !== 'admin').map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
        <select aria-label="Filtrar por período" value={periodo} onChange={e => setPeriodo(e.target.value)} style={{ minHeight:'40px', padding:'0 12px', border:'1px solid var(--divider)', borderRadius:'999px', background:'var(--surface)', color:'var(--text)' }}>
          <option value="7">Últimos 7 dias</option><option value="30">Últimos 30 dias</option><option value="90">Últimos 90 dias</option><option value="todos">Todo o período</option>
        </select>
        <label style={{ display:'flex', alignItems:'center', gap:'7px', color:'var(--text-2)', fontSize:'12px', cursor:'pointer' }}><input type="checkbox" checked={somenteAtencao} onChange={e => setSomenteAtencao(e.target.checked)} /> Precisa de atenção</label>
      </div>

      {(feedbacksTreino || []).filter(f => filtro === 'todos' || f.alunaId === filtro).length > 0 && (
        <div style={{ marginBottom:'28px' }}>
          <div style={{ fontSize:'11px', fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', color:'var(--accent)', marginBottom:'10px' }}>Revisões da primeira semana</div>
          {(feedbacksTreino || []).filter(f => filtro === 'todos' || f.alunaId === filtro).map(f => {
            const aluna = alunas.find(a => a.id === f.alunaId);
            const precisaAtencao = !f.aparelhos_disponiveis || !f.realizou_todos || f.dificuldade === 'dificil' || f.sentiu_dor || f.substituir_exercicio;
            return <div key={f.id} style={{ ...s.checkinCard, padding:'18px 22px', borderColor:precisaAtencao?'rgba(229,57,53,.3)':'rgba(76,175,80,.25)' }}>
              <div style={{ display:'flex', justifyContent:'space-between', gap:'12px', marginBottom:'10px' }}>
                <div><strong style={{ fontSize:'14px' }}>{aluna?.name || 'Aluna'}</strong><div style={s.checkinMeta}>{formatDate(f.criadoEm)}</div></div>
                <span style={{ ...s.progressoBadge, color:precisaAtencao?'#C62828':'#2E7D32', background:precisaAtencao?'rgba(229,57,53,.08)':'rgba(76,175,80,.09)' }}>{precisaAtencao?'Revisar ficha':'Tudo adequado'}</span>
              </div>
              <div style={{ display:'flex', flexWrap:'wrap', gap:'6px' }}>
                <span style={s.metaChip}>Aparelhos: {f.aparelhos_disponiveis?'sim':'não'}</span><span style={s.metaChip}>Fez todos: {f.realizou_todos?'sim':'não'}</span><span style={s.metaChip}>Dificuldade: {f.dificuldade}</span><span style={s.metaChip}>Dor: {f.sentiu_dor?'sim':'não'}</span><span style={s.metaChip}>Substituição: {f.substituir_exercicio?'sim':'não'}</span>
              </div>
              {f.comentario && <div style={{ marginTop:'10px', fontSize:'12px', color:'var(--text-3)', lineHeight:1.5 }}>“{f.comentario}”</div>}
            </div>;
          })}
        </div>
      )}

      {checkinsFiltrados.length === 0 ? (
        <div style={s.empty}>Nenhum check-in registrado ainda.</div>
      ) : (
        [...checkinsFiltrados].reverse().map(ck => {
          const treino = treinos.find(t => t.id === ck.treinoId);
          const aluna = alunas.find(a => a.id === ck.alunaId);
          const concluidos = ck.exercicios?.filter(e => e.concluido).length || 0;
          const total = ck.exercicios?.length || 0;
          const completo = total > 0 && concluidos === total;
          const aberto = !!abertos[ck.id];
          return (
            <div key={ck.id} style={s.checkinCard}>
              <div style={s.checkinHeader} onClick={() => toggleAberto(ck.id)}>
                <div style={{ minWidth: 0 }}>
                  <div style={s.checkinTitle}>{aluna?.name || 'Aluna'}</div>
                  <div style={s.checkinMeta}>{treino?.titulo || 'Treino'} · {formatDate(ck.criadoEm)}</div>
                  {ck.notaGeral && <div style={{ ...s.checkinMeta, color:SENSACAO[ck.notaGeral]?.color }}>Sensação geral: {SENSACAO[ck.notaGeral]?.label}</div>}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
                  <div style={{ ...s.progressoBadge, color: completo ? '#2E7D32' : 'var(--accent)', background: completo ? 'rgba(76,175,80,0.1)' : 'rgba(137,91,64,0.1)' }}>
                    {completo ? '✓ Completo' : `${concluidos}/${total}`}
                  </div>
                  <svg style={{ ...s.chevron, transform: aberto ? 'rotate(180deg)' : 'none' }} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>
                </div>
              </div>
              {aberto && ck.exercicios?.map((ex, idx) => (
                <div key={idx} style={{ ...s.exercicioRow, borderTop: idx === 0 ? '1px solid rgba(37,28,25,0.06)' : s.exercicioRow.borderBottom }}>
                  <div style={ex.concluido ? s.checkDone : s.checkPending}>{ex.concluido ? '✓' : ''}</div>
                  <div>
                    <div style={s.exNome}>{ex.nome}</div>
                    {ex.carga && <div style={s.exMeta}>Carga: {ex.carga}</div>}
                    {ex.obs && <div style={s.exObs}>"{ex.obs}"</div>}
                  </div>
                  {ex.sensacao && (
                    <div style={{ ...s.badge, color: SENSACAO[ex.sensacao]?.color, background: SENSACAO[ex.sensacao]?.bg }}>
                      {SENSACAO[ex.sensacao]?.label}
                    </div>
                  )}
                </div>
              ))}
            </div>
          );
        })
      )}
    </AdminLayout>
  );
}
